<template>
    <div>
        <div class="dx-field">
            <div class="dx-field-label">Дата решения о предст. исключ. из ЕГРЮЛ</div>
            <div class="dx-field-value">
                <dx-date-box :value="data.ac_egr_exclude_decision_date" />
            </div>
        </div>
    </div>
</template>

<script setup>
import { inject } from 'vue';
import { DxDateBox } from 'devextreme-vue';

const data = inject('serverData');
</script>
